import React, { useState, useEffect } from "react";
import { Layout, Menu, Button } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
import {
  HomeOutlined,
  CheckCircleOutlined,
  TeamOutlined,
  LogoutOutlined,
  UsergroupAddOutlined,
  IssuesCloseOutlined,
  LineChartOutlined,
  SettingOutlined,
  UserAddOutlined,
  ContactsOutlined,
  KeyOutlined,
  StarOutlined,
  GiftOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  CodeOutlined,
  CustomerServiceOutlined,
  CloseOutlined,
  FundProjectionScreenOutlined,
  PhoneOutlined,
  SubnodeOutlined,
  InteractionOutlined,
  ContainerOutlined,
  MailOutlined,
  BellOutlined,
  PlusCircleOutlined,
  CompassOutlined,
  BookOutlined,
  EnvironmentOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import Nav from "../../../components/Nav/Nav";
import GuestHome from "../../../assets/Icons/guesthome.jpg";
import sidebarStyles from "../../../components/Sidebar/sidebarStyles.js";

const { Sider, Header, Content, Footer } = Layout;

// A simple hook to get the window width
const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowWidth;
};

const Dashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  // --- FIX STARTS HERE ---
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 768; // Tailwind's `md` breakpoint

  // Determine the correct sidebar width for the margin
  const desktopSidebarWidth = collapsed ? 80 : 250;
  const contentMarginLeft = isMobile ? 0 : desktopSidebarWidth;
  // --- FIX ENDS HERE ---

  const menuItems = [
    // Menu items remain unchanged
    {
      key: "1",
      icon: <LineChartOutlined />,
      label: "Dashboard",
      onClick: () => {
        navigate("/home");
        setMobileOpen(false);
      },
    },
    {
      key: "2",
      icon: <UsergroupAddOutlined />,
      label: "Agent List",
      onClick: () => {
        navigate("/agent-list");
        setMobileOpen(false);
      },
    },
    {
      key: "3",
      icon: <TeamOutlined />,
      label: "Customer List",
      onClick: () => {
        navigate("/customer-list");
        setMobileOpen(false);
      },
    },
    {
      key: "4",
      icon: <ContactsOutlined />,
      label: "Agent Payment",
      onClick: () => {
        navigate("/agent-payment");
        setMobileOpen(false);
      },
    },
    {
      key: "5",
      icon: <HomeOutlined />,
      label: "Houses",
      children: [
        {
          key: "6",
          icon: <HomeOutlined />,
          label: "House List",
          onClick: () => {
            navigate("/house-list");
            setMobileOpen(false);
          },
        },
        {
          key: "7",
          icon: <CheckCircleOutlined />,
          label: "Approved House",
          onClick: () => {
            navigate("/approved-house");
            setMobileOpen(false);
          },
        },
        {
          key: "8",
          icon: <IssuesCloseOutlined />,
          label: "Approve House",
          onClick: () => {
            navigate("/not-approved-house");
            setMobileOpen(false);
          },
        },
      ],
    },
    {
      key: "9",
      icon: <UserAddOutlined />,
      label: "Admins",
      children: [
        {
          key: "10",
          icon: <CustomerServiceOutlined />,
          label: "Customer Support",
          onClick: () => {
            navigate("/create-account");
            setMobileOpen(false);
          },
        },
        {
          key: "11",
          icon: <CodeOutlined />,
          label: "System Admin",
          onClick: () => {
            navigate("/system-admins");
            setMobileOpen(false);
          },
        },
        {
          key: "12",
          icon: <FundProjectionScreenOutlined />,
          label: "Sales Admin",
          onClick: () => {
            navigate("/sales-admins");
            setMobileOpen(false);
          },
        },
      ],
    },
    {
      key: "13",
      icon: <SubnodeOutlined />,
      label: "Hotel Subscriptions",
      children: [
        {
          key: "14",
          icon: <InteractionOutlined />,
          label: "Subscription Transaction",
          onClick: () => {
            navigate("/subscription-transaction");
            setMobileOpen(false);
          },
        },
        {
          key: "15",
          icon: <ContainerOutlined />,
          label: "Subscription Activation",
          onClick: () => {
            navigate("/subscription-activation");
            setMobileOpen(false);
          },
        },
        {
          key: "16",
          icon: <ContainerOutlined />,
          label: "Subscription Plans",
          onClick: () => {
            navigate("/subscription-plans");
            setMobileOpen(false);
          },
        },
        {
          key: "17",
          icon: <InteractionOutlined />,
          label: "Subscription Modules",
          onClick: () => {
            navigate("/subscription-modules");
            setMobileOpen(false);
          },
        },
      ],
    },
    {
      key: "18",
      icon: <PhoneOutlined />,
      label: "Demo Requests",
      onClick: () => {
        navigate("/demo-requests");
        setMobileOpen(false);
      },
    },
    {
      key: "tour-mgmt",
      icon: <CompassOutlined />,
      label: "Tour Management",
      children: [
        {
          key: "tour-dashboard",
          icon: <LineChartOutlined />,
          label: "Dashboard",
          onClick: () => {
            navigate("/tour-dashboard");
            setMobileOpen(false);
          },
        },
        {
          key: "tour-bookings",
          icon: <BookOutlined />,
          label: "Bookings",
          onClick: () => {
            navigate("/tour-bookings");
            setMobileOpen(false);
          },
        },
        {
          key: "tour-agents",
          icon: <TeamOutlined />,
          label: "Agents",
          onClick: () => {
            navigate("/tour-agents");
            setMobileOpen(false);
          },
        },
        {
          key: "tour-tours",
          icon: <EnvironmentOutlined />,
          label: "Tours",
          onClick: () => {
            navigate("/tour-tours");
            setMobileOpen(false);
          },
        },
        {
          key: "tour-disputes",
          icon: <ExclamationCircleOutlined />,
          label: "Disputes",
          onClick: () => {
            navigate("/tour-disputes");
            setMobileOpen(false);
          },
        },
      ],
    },
    { type: "divider" },
    {
      key: "19",
      icon: <StarOutlined />,
      label: "Discount",
      onClick: () => {
        navigate("/discount");
        setMobileOpen(false);
      },
    },
    {
      key: "20",
      icon: <GiftOutlined />,
      label: "Giveaway",
      onClick: () => {
        navigate("/giveaway");
        setMobileOpen(false);
      },
    },
    { type: "divider" },
    {
      key: "21",
      icon: <BellOutlined />,
      label: "Push Notification",
      onClick: () => {
        navigate("/push-notification");
        setMobileOpen(false);
      },
    },
    {
      key: "22",
      icon: <PlusCircleOutlined />,
      label: "Post Ads",
      onClick: () => {
        navigate("/post-ads");
        setMobileOpen(false);
      },
    },
    {
      key: "23",
      icon: <MailOutlined />,
      label: "Email",
      onClick: () => {
        navigate("/email-config");
        setMobileOpen(false);
      },
    },
    {
      key: "24",
      icon: <KeyOutlined />,
      label: "Account",
      onClick: () => {
        navigate("/change-password");
        setMobileOpen(false);
      },
    },
    {
      key: "25",
      icon: <SettingOutlined />,
      label: "Setting",
      onClick: () => {
        navigate("/setting");
        setMobileOpen(false);
      },
    },
    {
      key: "26",
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: () => navigate("/logout"),
    },
  ];

  return (
    <Layout className="min-h-screen">
      <style>{sidebarStyles}</style>

      {/* --- Desktop Sidebar (Fixed) --- */}
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        trigger={null}
        className="hidden md:flex main-sidebar flex-col"
        width={250}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <div className="admin-card flex items-center gap-3">
          <div className="profile-pic-wrapper">
            <img
              src={GuestHome}
              alt="Admin Avatar"
              className="w-full h-full object-cover"
            />
          </div>
          {!collapsed && (
            <div className="admin-info">
              <span className="text-base font-semibold block">GuestHome</span>
              <span className="admin-role block">Administrator</span>
            </div>
          )}
        </div>
        <Menu
          defaultSelectedKeys={["1"]}
          mode="inline"
          items={menuItems}
          inlineCollapsed={collapsed}
        />
      </Sider>

      {/* --- Mobile Sidebar (Overlay) --- */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50 md:hidden"
          onClick={() => setMobileOpen(false)}
        >
          <Sider
            className="h-full main-sidebar shadow-lg flex flex-col"
            width={240}
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
          >
            <div className="p-4 flex justify-between items-center border-b border-gray-600">
              <span className="text-white font-semibold text-lg">Menu</span>
              <Button
                className="text-white"
                type="text"
                icon={<CloseOutlined />}
                onClick={() => setMobileOpen(false)}
              />
            </div>
            <Menu defaultSelectedKeys={["1"]} mode="inline" items={menuItems} />
          </Sider>
        </div>
      )}

      {/* --- Main Content Layout --- */}
      <Layout
        className="flex-1 flex flex-col transition-all duration-300"
        style={{ marginLeft: contentMarginLeft }}
      >
        <Header className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center">
            {/* Desktop Toggle */}
            <Button
              className="hidden md:block bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-white rounded-md border-none mr-4"
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
            />
            {/* Mobile Toggle */}
            <Button
              className="md:hidden bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-white rounded-md border-none"
              type="default"
              onClick={() => setMobileOpen(true)}
            >
              <MenuUnfoldOutlined />
            </Button>
          </div>
          <div className="flex-grow">
            <Nav />
          </div>
        </Header>
        <Content className="flex-1 p-4 bg-gray-100 dark:bg-gray-800">
          <Outlet />
        </Content>
        <Footer className="bg-white dark:bg-gray-900 text-center p-4 text-gray-600 dark:text-gray-300">
          GuestHome PLC ©{new Date().getFullYear()}
        </Footer>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
